// Auto-hide
//
var siteNavbar = document.getElementById("site-navbar");

if (siteNavbar) {

	var lastScrollTop = 0;

	document.addEventListener("scroll", function () {

		var st = document.documentElement.scrollTop;

		if (Math.abs(st-lastScrollTop) > 5) {
			if (st < lastScrollTop)
				siteNavbar.classList.remove("site-navbar-up");
			else if (st > 100)
				siteNavbar.classList.add("site-navbar-up");
		}

		lastScrollTop = st;

		[].forEach.call(document.getElementsByClassName("dropdown-toggle"), function (element) {
			bootstrap.Dropdown.getOrCreateInstance(element).hide();
		});

		[].forEach.call(document.querySelectorAll('[data-bs-toggle="popover"]'), function (element) {
			bootstrap.Popover.getOrCreateInstance(element).hide()
		});
	});
}

// Employer autocomplete

[].forEach.call(document.getElementsByClassName("employer-autocomplete"), function (selectElement) {

	var picker = document.createElement("input");
	picker.type = "text";
	picker.classList.add("form-control");
	picker.setAttribute("id", "employerAutocomplete");
	if (selectElement.required) picker.setAttribute("required", "");

	selectElement.parentElement.appendChild(picker);

	selectElement.style.display = "none";
	selectElement.parentElement.classList.add("position-relative");

	data = [];
	for (i = 0; i < selectElement.options.length; i++) {
		text = selectElement.options[i].text;
		value = selectElement.options[i].value;
		if (!value)
			continue;
		data[text] = value;
	}
	autocomplete(picker, data, {
		strict: true,
		select: function (element) {
			picker.value = element.textContent;
			selectElement.value = element.dataset.value;
		}
	});
});
